interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  center?: boolean;
}

export default function SectionHeading({ eyebrow, title, desc, center }: SectionHeadingProps) {
  return (
    <div className={center ? "mx-auto max-w-2xl text-center" : "max-w-2xl"}>
      <span className="inline-flex items-center gap-1.5 whitespace-nowrap text-xs font-bold uppercase tracking-widest text-primary-500">
        <span className="h-px w-6 bg-primary-400"></span>
        {eyebrow}
      </span>
      <h2 className="mt-3 font-heading text-2xl font-bold leading-tight text-foreground-950 md:text-[2rem]">
        {title}
      </h2>
      {desc && <p className="mt-3 text-sm leading-6 text-foreground-600 md:text-base md:leading-7">{desc}</p>}
    </div>
  );
}